<script lang="ts">
  import moneyFormatters from "@shared/filters/money.js";

  export let minPurchase: number = 0;
  export let minQuantity: string = "";
  export let truncateOrderMinimum: boolean = true;

  const formattedMinPurchase = moneyFormatters.filter()(minPurchase).replace(/\.00$/, "");
  let orderMinimumString = `${formattedMinPurchase}`;
  if (!!minPurchase && !!minQuantity) {
    orderMinimumString += ` or ${minQuantity}`;
  } else if (!!minQuantity) {
    orderMinimumString = `${minQuantity}`;
  }

</script>

<p class="fizz-inline-4" class:fizz-truncate={truncateOrderMinimum}>
  {orderMinimumString} min
</p>
